import { DialogActions, Button } from "@mui/material";
import React, { useCallback, useState } from "react";
import { batchPrintStepsType } from "../../../../customTypes/batchPrintModal"
import { batchPrintStepsObject, handleSubmitTcns } from '../../utils/helpers';
import { useMUITheme } from '../../../../theme/ThemeProvider';
import { useBatchPrint } from '../../../../hooks';
import { useTableStore } from '../../../../state/TableStore';
import { useAudit } from '../../../../hooks/useAudit';
import { EXPIRATION_TIME_PDF } from "../PrintModal";

interface IBatchPrintModalAction {
    batchPrintSteps: batchPrintStepsType,
    setBatchPrintSteps: React.Dispatch<batchPrintStepsType>,
    handleClose: Function,
    handleInitiateCancel: () => void,
    handleConfirmCancel: () => void,
    handleResumeFlow: () => void,
    tcns: string[],
    setResp: React.Dispatch<any>,
    page: number,
    rowsPerPage: number,
    setPercentComplete: React.Dispatch<number>,
    setRemaining: React.Dispatch<number>,
    setPdfAvailable: React.Dispatch<boolean>,
    handleOpenPrint: Function
}

const BatchPrintingModalAction: React.FC<IBatchPrintModalAction> = ({
    batchPrintSteps,
    setBatchPrintSteps,
    handleClose,
    handleInitiateCancel,
    handleConfirmCancel,
    handleResumeFlow,
    tcns,
    setResp,
    page,
    rowsPerPage,
    setPercentComplete,
    setRemaining,
    setPdfAvailable,
    handleOpenPrint
}) => {
    const { mode } = useMUITheme();

    const searchParams = useTableStore(state => state.searchParams)
    const setSearchParams = useTableStore(state => state.setSearchParams)
    const setHeaderButtonConfig = useTableStore(state => state.setHeaderButtonConfig)
    const setSelected = useTableStore(state => state.setSelected)
    const selected = useTableStore(state => state.selected)
    const headerButtonConfig = useTableStore(state => state.headerButtonConfig)
    const setTcns = useTableStore(state => state.setTcns)
    const [submissionSuccessful, setShowSubmissionSuccessful] = useState(false)
    const { addAuditEvent } = useAudit()

    const openPrintConfirm = () => {
        setBatchPrintSteps({
            ...batchPrintStepsObject,
            stepA_Confirm: false,
            stepD_Confirm: true,
        })
    }

    const runPostConfirmActions = useCallback(() => {
        console.log('debug runPostConfirmActions: ', {
            setHeaderButtonConfig,
            setSelected,
        })

        setBatchPrintSteps({
            ...batchPrintStepsObject,
            stepA_Confirm: false,
        })
        handleClose()
        setSearchParams(searchParams.map((param: any) => ({ ...param })))
        setHeaderButtonConfig({ ...headerButtonConfig, disabled: true })
        setShowSubmissionSuccessful(false)
        setResp({})
        setSelected([])
        setTcns([])

        tcns.forEach((tcn: any) => {
            console.log('Debug tcns key: ', tcn.key);
            addAuditEvent("Printed Successful", "Batchprint / Selected Applicant", new Date(), tcn.key)
        })
    }, [searchParams, setSearchParams, setHeaderButtonConfig, setSelected, addAuditEvent, handleClose, headerButtonConfig, setBatchPrintSteps, setResp, setTcns, tcns])

    const { handlePrintConfirm } = useBatchPrint(rowsPerPage, page, searchParams)

    return (
        <DialogActions sx={{ pr: '24px', gap: '8px' }}>
            {
                batchPrintSteps.stepA_Confirm
                && (<Button onClick={() => {
                    setBatchPrintSteps(batchPrintStepsObject);
                    handleClose();
                }} variant="outlined" sx={{ color: mode === 'dark' ? 'text.primary' : '' }}>
                    CANCEL
                </Button>)
            }
            {
                batchPrintSteps.stepA_Confirm && (
                    <Button disabled={!!submissionSuccessful} onClick={() => handleSubmitTcns(setBatchPrintSteps, tcns, setResp)} variant="contained" color='secondary'>
                        Continue
                    </Button>
                )
            }
            {
                batchPrintSteps.stepB_PreparePdf && (
                    <Button onClick={() => handleInitiateCancel()} variant="outlined" sx={{ color: mode === 'dark' ? 'text.primary' : '' }}>
                        CANCEL
                    </Button>
                )
            }
            {
                batchPrintSteps.stepC_DocumentReady && (
                    <>
                        <Button onClick={openPrintConfirm} variant="contained" color='secondary'>Continue</Button>
                        <Button onClick={() => handleClose()} variant="outlined" sx={{ color: mode === 'dark' ? 'text.primary' : '' }}>
                            CANCEL
                        </Button>
                    </>
                )
            }
            {
                batchPrintSteps.stepD_Confirm && (
                    <>
                        <Button onClick={() => handleClose()} variant="outlined" sx={{ color: mode === 'dark' ? 'text.primary' : '' }}>
                            CANCEL
                        </Button>
                        <Button onClick={async () => {
                            setBatchPrintSteps({
                                ...batchPrintStepsObject,
                                stepA_Confirm: false,
                                confirmingPrintJobs: true
                            })

                            handlePrintConfirm(selected, searchParams).then(() => {
                                runPostConfirmActions()
                            })
                        }}
                            variant="contained"
                            disabled={selected.length === 0}
                            color='secondary'>
                            Confirm
                        </Button>
                    </>
                )
            }
            {
                (batchPrintSteps.cancelConfirmPrint || batchPrintSteps.cancelConfirmError) && (
                    <>
                        <Button onClick={handleConfirmCancel} variant="contained" color='secondary'>
                            Yes, Cancel
                        </Button>

                        <Button onClick={handleResumeFlow} variant="outlined" sx={{ color: mode === 'dark' ? 'text.primary' : '' }}>
                            No, Continue
                        </Button>
                    </>
                )
            }
            {
                (batchPrintSteps.pdfGenError || batchPrintSteps.docExpired) && (
                    <Button onClick={() => {
                        setPercentComplete(0);
                        setBatchPrintSteps({
                            ...batchPrintStepsObject,
                            stepA_Confirm: false,
                            stepB_PreparePdf: true,
                        });
                        setRemaining(EXPIRATION_TIME_PDF);
                        setPdfAvailable(false);
                        handleOpenPrint()
                    }} variant="contained" color='secondary'>Try Again</Button>

                )
            }
        </DialogActions>
    )
}

export default BatchPrintingModalAction;